module.exports = __webpack_public_path__ + "img/paypal-logo.29887b41.svg";